import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import { useContext } from 'react';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import PortfolioIsReadOnlyContext from '@/lib/contexts/PortfolioIsReadOnlyContext';

type StyledIndicatorProps = {
  partHasFocus: boolean;
};

const StyledIndicator = styled('span')<StyledIndicatorProps>(
  ({ theme }) => ({
    marginLeft: 6,
    width: 10,
    height: 10,
    flexShrink: 0,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
  }),
  ({ theme, partHasFocus }) => {
    if (theme.palette.isHighContrast && partHasFocus) {
      return {
        backgroundColor: theme.isDark ? '#000000' : '#FFFFFF',
      };
    }
  },
);

type UnreadCoachCommentsIndicatorProps = {
  levelIds: number[];
  partHasFocus: boolean;
};

const UnreadCoachCommentsIndicator = ({
  levelIds,
  partHasFocus,
}: UnreadCoachCommentsIndicatorProps) => {
  const intl = useIntl();
  const portfolioIsReadonly = useContext(PortfolioIsReadOnlyContext);

  const [portfolio] = useContext(RubricsPortfolioContext);

  const unreadCoachComments = levelIds.flatMap(levelId => {
    if (
      typeof portfolio.levelProgressCoachComments?.[levelId] === 'undefined'
    ) {
      return [];
    }

    return Object.values(portfolio.levelProgressCoachComments[levelId]).filter(
      coachComment => !coachComment.isRead,
    );
  });

  if (unreadCoachComments.length === 0 || portfolioIsReadonly) {
    return null;
  }

  return (
    <Tooltip
      title={intl.formatMessage(
        {
          id: `portfolio.part.unread_coach_comments_indicator.${unreadCoachComments.length > 1 ? 'plural' : 'singular'}`,
        },
        {
          unreadCoachCommentsCount: unreadCoachComments.length,
        },
      )}
    >
      <StyledIndicator partHasFocus={partHasFocus} />
    </Tooltip>
  );
};

export default UnreadCoachCommentsIndicator;
